import React from 'react'
import { Helmet } from 'react-helmet'
import utils from '../utils'
import HomeCTA from '../components/home/HomeCTA'
import HomeHero from '../components/home/HomeHero'
import { BsClock } from "react-icons/bs"
import { MdOutlineLandscape } from 'react-icons/md'
import { BsShieldCheck } from "react-icons/bs"
import HouseList from '../components/home/HouseList'
import TestimonialsSection from '../components/home/HomeTestimonials'
import events from '../assets/events.jpeg'

function HomeFeatures() {
  const features = [
    {
      icon: <BsShieldCheck />,
      title: "Secure & Safe Stay",
      description: "Your safety is non-negotiable. We provide 24/7 professional security and continuous CCTV surveillance across the entire property."
    },
    {
      icon: <MdOutlineLandscape />,
      title: "Lake Victoria Views",
      description: "Wake up to panoramic vistas of Africa's largest lake — your serene backdrop for work, rest, or celebration."
    },
    {
      icon: <BsClock />,
      title: "24/7 Support",
      description: "Questions at 2 AM? Need extra towels? Our team is just a call or message away, day or night."
    }
  ]

  return (
    <section className="bg-[#F8F9F7] py-16">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">

        {features.map((feature, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center group"
          >
            <div className="w-16 h-16 rounded-full bg-[#1B4D3E]/5 flex items-center justify-center mb-6 text-[#1B4D3E] group-hover:bg-[#E87A25]/10 group-hover:text-[#E87A25] transition-colors duration-300">
              <div className="text-3xl">
                {feature.icon}
              </div>
            </div>
            <h3 className="font-serif text-xl font-bold text-[#0F1715] mb-3">
              {feature.title}
            </h3>
            <p className="text-[#6B7C76] text-sm max-w-xs leading-relaxed">
              {feature.description}
            </p>
          </div>
        ))}

      </div>
    </section>
  )
}

function HomePage() {
  return (
    <div>
      <Helmet>
        <title>Home - {utils.siteName}</title>
      </Helmet>
      <HomeHero />
      <HomeFeatures />
      <HouseList />
      <section className="py-12 lg:py-20 bg-[#FAFAFA]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">

            <div className="order-2 lg:order-1 w-full lg:w-1/2">
              <span className="text-xs uppercase tracking-widest font-label text-outline text-secondary mb-6 block">
                Beyond Accommodation
              </span>
              <h2 className="text-3xl md:text-4xl font-headline text-primary mb-8 leading-tight">
                Curated Events & Venue Management
              </h2>

              <p className="text-[#6B7C76] text-lg leading-relaxed mb-8">
                From high-stakes corporate functions to intimate gatherings in our private residences,
                we provide seamless venue management that prioritizes distinction. Our spaces are
                designed to adapt to your vision, ensuring every event is as unique as its host.
              </p>

              <ul className="space-y-4">
                {[
                  "Corporate Meeting Packages",
                  "Private Residential Gatherings",
                  "Full-Scale Event Coordination"
                ].map((item, i) => (
                  <li key={i} className="flex items-center gap-4 text-[#0F1715] font-medium text-base">
                    <div className="w-6 h-6 rounded-full bg-[#E87A25]/10 flex items-center justify-center text-[#E87A25] flex-shrink-0">
                      <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="order-1 lg:order-2 w-full lg:w-1/2 flex-shrink-0">
              <div className="relative overflow-hidden rounded-3xl h-[380px] lg:h-[540px] shadow-xl">
                <img
                  alt="Elegant outdoor corporate event setup with white tents"
                  className="w-full h-full object-cover"
                  src={events}
                />
              </div>
            </div>

          </div>
        </div>
      </section>
      <TestimonialsSection />
      <HomeCTA />
    </div>
  )
}

export default HomePage